var map = {
	"./audio/ringtone.mp3": 409,
	"./images/anytime-anywhere.svg": 1448,
	"./images/app-store-badge.svg": 633,
	"./images/assessment.png": 249,
	"./images/assessment.svg": 1449,
	"./images/babylon_us_ios_app.png": 208,
	"./images/card-payment.jpg": 1450,
	"./images/chart.png": 1451,
	"./images/check-bullet.svg": 1452,
	"./images/dr-maz-alsaffar.jpg": 668,
	"./images/icon_gcal.png": 1436,
	"./images/icon_ical.png": 1437,
	"./images/icon_outlook.png": 1438,
	"./images/injection-instructions/global-checkin-norefill.mp4": 693,
	"./images/injection-instructions/wegovy-cap-pen.mp4": 690,
	"./images/injection-instructions/wegovy-check-clarity.mp4": 678,
	"./images/injection-instructions/wegovy-check-dose.mp4": 559,
	"./images/injection-instructions/wegovy-check-flow-for-drop.mp4": 684,
	"./images/injection-instructions/wegovy-check-flow.mp4": 683,
	"./images/injection-instructions/wegovy-choose-injection-site.mp4": 686,
	"./images/injection-instructions/wegovy-clean-the-injection-site.mp4": 687,
	"./images/injection-instructions/wegovy-drop-or-not.mp4": 685,
	"./images/injection-instructions/wegovy-inject-allsteps-waist.mp4": 688,
	"./images/injection-instructions/wegovy-inject-remove-needle.mp4": 689,
	"./images/injection-instructions/wegovy-innercap-remove.mp4": 682,
	"./images/injection-instructions/wegovy-needle-box-and-paper-off.mp4": 679,
	"./images/injection-instructions/wegovy-outercap-remove.mp4": 681,
	"./images/injection-instructions/wegovy-pencap-remove.mp4": 677,
	"./images/injection-instructions/wegovy-pencap-replace.mp4": 692,
	"./images/injection-instructions/wegovy-remove-needle.mp4": 691,
	"./images/injection-instructions/wegovy-twist-on-needle.mp4": 680,
	"./images/lifestyle-health.svg": 1453,
	"./images/logo/ask-a-and-e--square.png": 1454,
	"./images/logo/ask-a-and-e.png": 1455,
	"./images/logo/babylon--square.png": 1456,
	"./images/logo/babylon-brazil-einstein--square.png": 1457,
	"./images/logo/babylon-brazil-einstein.png": 1458,
	"./images/logo/babylon.png": 1459,
	"./images/logo/bupa.png": 1460,
	"./images/logo/columbus-direct.png": 1461,
	"./images/logo/eMed-heart.png": 659,
	"./images/logo/gp-at-hand.png": 1462,
	"./images/logo/nhs-rwt.png": 1463,
	"./images/logo/nhs-services.png": 1464,
	"./images/logo/nhs-uhb-ed.png": 1465,
	"./images/logo/nhs.png": 1466,
	"./images/logo/none.png": 1467,
	"./images/logo/united-healthcare.png": 1468,
	"./images/logo_square.png": 1434,
	"./images/map-pin-blank.svg": 1439,
	"./images/map-pin-generic.svg": 1440,
	"./images/map-pin-pharmacy.svg": 1435,
	"./images/nhs-logo.svg": 1441,
	"./images/ozempic-inject-allsteps-waist.mp4": 676,
	"./images/play-store-badge.svg": 634,
	"./images/waves.svg": 1469,
	"./images/weight-loss_clinician-call.jpg": 675,
	"./images/weight-loss_female-doctor.jpg": 669,
	"./images/weight-loss_get-your-medication.jpg": 670,
	"./images/weight-loss_gym.jpg": 666,
	"./images/weight-loss_hands.png": 313,
	"./images/weight-loss_lose-weight.jpg": 671,
	"./images/weight-loss_person-on-scales.jpg": 412,
	"./images/weight-loss_scale.png": 312,
	"./images/weight-loss_science.jpg": 1470,
	"./images/weight-loss_syringe.png": 311,
	"./images/weight-loss_video.png": 1471,
	"./images/weight-loss_wegovy.jpg": 314,
	"./images/welcome_screen.jpg": 663,
	"./info-icon.svg": 1472,
	"./logo_heart.png": 1473,
	"./logo_heart_small.png": 1474
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context */ 35).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 1190;
module.exports = webpackAsyncContext;